import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ExamsService } from "../exams.service";
import { AutoTextList, AutoTextSnippet } from "../clinic-autotext/clinic-autotext.component";

@Component({
    selector: "app-clinic-autotext-popup",
    templateUrl: "./clinic-autotext-popup.component.html",
    styleUrls: ["./clinic-autotext-popup.component.scss"],
    standalone: false
})
export class ClinicAutotextPopupComponent implements OnChanges {
  @Input() clinicTemplateId: number | string = null;
  @Input() clinicTemplateTitle = "";
  @Input() display = false;
  @Output() close = new EventEmitter<void>();

  lists: AutoTextList[] = [];
  title = "";
  snippets: AutoTextSnippet[] = [{ Content: "" }];
  editingId: number | null = null;
  currentAssignedIds = new Set<any>();
  loading = false;
  showDeleteConfirm = false;
  listToDelete: AutoTextList = null;

  constructor(public es: ExamsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.display && this.display) {
      this.resetForm();
      this.load();
    }
  }

  get scopedLists(): AutoTextList[] {
    return (this.lists || []).filter(
      (l) => (l.assignedClinicTemplateIds || []).some((id) => id == this.clinicTemplateId)
    );
  }

  load() {
    try {
      this.es.getAutoTextLists().subscribe(
        (data: any) => { this.lists = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  addSnippetRow() {
    this.snippets.push({ Content: "" });
  }
  removeSnippetRow(i: number) {
    this.snippets.splice(i, 1);
    if (!this.snippets.length) this.addSnippetRow();
  }

  resetForm() {
    this.editingId = null;
    this.title = "";
    this.snippets = [{ Content: "" }];
    this.currentAssignedIds = new Set<any>([this.clinicTemplateId]);
  }

  save() {
    if (!this.title || this.loading) return;
    const body = {
      Title: this.title,
      snippets: this.snippets.filter((s) => s.Content),
      assignedClinicTemplateIds: [...this.currentAssignedIds],
    };
    this.loading = true;
    try {
      const obs = this.editingId
        ? this.es.updateAutoTextList(this.editingId, body)
        : this.es.createAutoTextList(body);
      obs.subscribe(
        (data: any) => { this.lists = data || []; this.resetForm(); this.loading = false; },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  edit(l: AutoTextList) {
    this.editingId = l.AutoTextListID;
    this.title = l.Title;
    this.snippets = (l.snippets && l.snippets.length) ? l.snippets.map((s) => ({ ...s })) : [{ Content: "" }];
    this.currentAssignedIds = new Set<any>(l.assignedClinicTemplateIds || []);
    this.currentAssignedIds.add(this.clinicTemplateId);
  }

  confirmDelete(l: AutoTextList) {
    this.listToDelete = l;
    this.showDeleteConfirm = true;
  }
  cancelDelete() {
    this.listToDelete = null;
    this.showDeleteConfirm = false;
  }
  doDelete() {
    if (!this.listToDelete || this.loading) return;
    const id = this.listToDelete.AutoTextListID;
    this.loading = true;
    try {
      this.es.deleteAutoTextList(id).subscribe(
        (data: any) => {
          this.lists = data || [];
          this.showDeleteConfirm = false;
          this.listToDelete = null;
          this.loading = false;
          if (this.editingId === id) this.resetForm();
        },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  doClose() {
    this.showDeleteConfirm = false;
    this.close.emit();
  }
}
